import React from 'react'
import { makeStyles } from '@mui/styles'
import classNames from 'classnames'
import CarouselArrow from './carousel-arrow'
import ArrowLeftSvg from 'assets/images/icons/arrow_left.svg'

export const CarouselLeftArrow = (props) => {
  const { onClick, className, customClass, smallArrow, fillColor } = props
  const classes = useStyles(props)
  const arrowClasses = classNames(customClass, className, classes.leftArrow)
  return (
    <CarouselArrow
      icon={ArrowLeftSvg}
      onClick={onClick}
      className={arrowClasses}
      smallArrow={smallArrow}
      fillColor={fillColor}
    />
  )
}

const useStyles = makeStyles(() => ({
  leftArrow: {
    left: '20px',
  },
}))

export default CarouselLeftArrow
